<template>
	<div class="courseView">
		<div class="courseView_left"  @mouseleave="hoverShow = -1">
			<div class="courseView_left_father">
				<div class="courseView_left__list" @mouseenter="hoverShow = index" v-for="(item,index) in courseList"
					:key="index">
					<p>{{item.name}}</p>
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>

			<div class="courseView_left__float" v-show="hoverShow == index" v-for="(items,index) in classes"
				:key="index">
				<div style="font-weight: bold;font-size: 16px;">{{titleList[index]}}</div>
				<div class="courseView_mid_out">
					<div class="courseView_mid__list" v-for="(item2,key) in items" :key="key" @click="goDetail(item2.id,item2.name,item2.parent_id,titleList[index])">
						<p>{{item2.name}}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="courseView_right">
			<el-carousel height="270px" style="width: 100%;">
				<el-carousel-item v-for="(item,key) in banner" :key="key">
					<el-image class="courseView_right__img" fit="fill" :src="item.path"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>

	</div>
</template>

<script>
	import {
		getClaes,
		getClassTags,
		getClassCate
	} from "../../../api/moudles/user";
	import {
		getWebBanner
	} from "../../../api/moudles/home";


	export default {
		data() {
			return {
				hoverShow: -1,
				courseList: [],
				banner: [],
				classes: [],
				titleList: [],
			}
		},
		created() {
			this.fetchData()
		},
		methods: {
			getClaList(cate, index) {
				getClaes({
					data: {
						tag: '',
						cate,
					},
					success: (res) => {
						this.$set(this.classes, index, res.data)
					}
				})
			},

			getClassCate(cate, index) {
				getClassCate({
					data: {
						parentCate:cate,
					},
					success: (res) => {
						this.$set(this.classes, index, res.data)
					}
				})
			},

			goDetail(id, name,parent_cate,parent_name) {
				this.$router.push({
					path: '/announce/list',
					query: {
						parent_cate: parent_cate,
						parent_name: parent_name,
						cate: id,
						name: name,
					}
				})
			},
			fetchData() {
				getClassTags({
					data: {},
					success: (res) => {
						this.courseList = res.data.cates
						const newRequireList = res.data.cates
						if (newRequireList.length) {
							newRequireList.forEach((item, index) => {
								this.titleList[index] = item.name
								this.getClassCate(item.id, index)
							})
						}
					}
				})
				getWebBanner({
					data: {
						column_code: '65863D49-1609-C371-7280-783850535709',
					},
					success: (res) => {
						this.banner = res.data
					}
				})
			}
		}

	}
</script>

<style scoped>
	.courseView {
		margin: 19px 0;
		height: 270px;
		width: 100%;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
	}

	.courseView_left {
		position: relative;
		width: 260px;
		height: 270px;
		background-color: #1D263B;
		display: flex;
		flex-flow: column;
		justify-content: center;
	}

	.courseView_left_father {
		height: 360px;
		overflow-y: scroll;
	}

	.courseView_left__float {
		position: absolute;
		height: 270px;
		min-width: 500px;
		padding: 20px 40px;
		box-sizing: border-box;
		left: 260px;
		top: 0;
		z-index: 990;
		background-color: #fff;
		border-radius: 0 8px 8px 0;
	}

	.courseView_left__list {
		height: 45px;
		padding: 0 30px;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.courseView_left__list:hover {
		cursor: pointer;
		background: #2D3A5A;
	}

	.courseView_left__list p {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		letter-spacing: 0;
		font-weight: 400;
		overflow: hidden;
	}

	.courseView_mid_out {
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
	}

	.courseView_mid__list {
		margin-right: 30px;
		margin-bottom: 10px;
	}

	.courseView_mid__list:hover {
		opacity: 0.7;
		cursor: pointer;
	}

	.courseView_right {
		width: calc(100% - 260px);
	}

	.courseView_right__img {
		width: 100%;
		height: 100%;
		transition: all .3s;
	}

	.courseView_right__img:hover {
		cursor: pointer;
		transform: scale(1.1);
	}
</style>
